export class EstimationItem {
  name: string;
  cost: number;
  costUnit: string;
  type: string;

  constructor(name: string, cost: number, costUnit: string, type: string = null) {
    this.name = name;
    this.cost = cost;
    this.costUnit = costUnit;
    this.type = type;
  }
}
